import script from "./MultiOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiOptions.vue?vue&type=script&setup=true&lang=js"

import "./MultiOptions.vue?vue&type=style&index=0&id=738e347f&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738e347f"]])

export default __exports__